export default "__VITE_PUBLIC_ASSET__a4442e6d__"